import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

/**
 * A button to press when the user wants to display a modal by
 * passing in a function to execute when clicked.
 */

const styles = theme => ({
	buttonStyle: {
		color: theme.palette.text.primary,
		fontFamily: theme.typography.fontFamily,
		cursor: 'pointer',
		backgroundColor: 'transparent',
		border: 'none',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		outline: 0,
	},
});

const FunctionButton = ({ classes, label, onClickFunction, style, className }) => (
	<button onClick={onClickFunction} style={style} className={`${classes.buttonStyle} ${className}`}>
		{label}
	</button>
);

FunctionButton.propTypes = {
	label: PropTypes.string,
	onClickFunction: PropTypes.func.isRequired,
	style: PropTypes.objectOf(PropTypes.any),
	className: PropTypes.string,
	classes: PropTypes.shape({
		buttonStyle: PropTypes.string,
	}).isRequired,
};

FunctionButton.defaultProps = {
	label: undefined,
	style: {},
	className: '',
};

export default withStyles(styles, { name: 'FunctionButton' })(FunctionButton);
